/** 非空时侧栏「设计测试 20」在新标签打开该地址（内网穿透 / 公网预览完整 URL，须含 path） */
const designTest20TunnelHref = String(process.env.DESIGN_TEST_20_TUNNEL_HREF || '').trim();

export const DESIGN_TEST_NAV_GROUPS = [
  {
    key: 'framework',
    title: '基础框架模板',
    items: [
      { path: '/design-test/d2c-workbench-template', label: 'D2C 工作台基础模板', name: 'DesignTestD2CWorkbenchTemplate' },
      { path: '/design-test/basic-framework-1', label: '基础框架 1', name: 'DesignTestBasicFramework1' },
      { path: '/design-test/rebar-1', label: '钢筋模板', name: 'DesignTestRebar1' },
      { path: '/design-test/concrete-1', label: '混凝土模板', name: 'DesignTestConcrete1' },
    ],
  },
  {
    key: 'mode-a-layouts',
    title: '标准布局 · 模式A（D2C 工作台壳）',
    items: [
      { path: '/design-test/mode-a-layout', label: '1 · KPI 条 + 明细表（工具栏槽）', name: 'DesignTestModeALayout' },
      { path: '/design-test/mode-a-layout-dual-table-midbar', label: '2 · 双表 + 中间工具条', name: 'DesignTestModeALayoutDualTableMidbar' },
      { path: '/design-test/mode-a-layout-triple-viewport', label: '3 · 左控 + 双画布', name: 'DesignTestModeALayoutTripleViewport' },
      { path: '/design-test/mode-a-layout-master-slave-panel', label: '4 · 主从面板', name: 'DesignTestModeALayoutMasterSlavePanel' },
      { path: '/design-test/mode-a-layout-nav-layers-tree-table', label: '5 · 多层导航 + 左树右表', name: 'DesignTestModeALayoutNavLayersTreeTable' },
      { path: '/design-test/mode-a-layout-sidebar-kpi-main-table', label: '6 · 侧栏 + KPI + 主表', name: 'DesignTestModeALayoutSidebarKpiMainTable' },
      { path: '/design-test/mode-a-layout-tabs-single-table', label: '7 · 页签 + 单表', name: 'DesignTestModeALayoutTabsSingleTable' },
      { path: '/design-test/mode-a-layout-tree-panel-right-table', label: '8 · 左树 + 右主表', name: 'DesignTestModeALayoutTreePanelRightTable' },
      { path: '/design-test/mode-a-layout-settings-dual-cards', label: '9 · 设置 + 双面板', name: 'DesignTestModeALayoutSettingsDualCards' },
    ],
  },
  // 侧栏 label：「设计测试 NN · 业务说明 vX」（Web / App 等）；新增条目须带内容与版本号，勿只写序号。
  {
    key: 'page-templates',
    title: '设计测试 · 页面模板',
    items: [
      {
        path: '/design-test/concrete-kpi-tree-table-property',
        label: '设计测试 01',
        name: 'DesignTestConcreteKpiTreeTableProperty',
      },
      { path: '/design-test/concrete-wb-ext-01', label: '设计测试 02', name: 'DesignTestConcreteWorkbenchExt01' },
      { path: '/design-test/concrete-wb-ext-02', label: '设计测试 03', name: 'DesignTestConcreteWorkbenchExt02' },
      { path: '/design-test/concrete-wb-ext-03', label: '设计测试 04', name: 'DesignTestConcreteWorkbenchExt03' },
      { path: '/design-test/mep-order-doc', label: '设计测试 05', name: 'DesignTestMepOrderDoc' },
      { path: '/design-test/framework-asm-01', label: '设计测试 06', name: 'DesignTestFrameworkAsm01' },
      { path: '/design-test/framework-asm-02', label: '设计测试 07', name: 'DesignTestFrameworkAsm02' },
      { path: '/design-test/framework-asm-03', label: '设计测试 08', name: 'DesignTestFrameworkAsm03' },
      { path: '/design-test/framework-asm-04', label: '设计测试 09', name: 'DesignTestFrameworkAsm04' },
      { path: '/design-test/framework-asm-05', label: '设计测试 10', name: 'DesignTestFrameworkAsm05' },
      { path: '/design-test/framework-asm-06', label: '设计测试 11', name: 'DesignTestFrameworkAsm06' },
      { path: '/design-test/framework-asm-07', label: '设计测试 12', name: 'DesignTestFrameworkAsm07' },
      { path: '/design-test/framework-asm-08', label: '设计测试 13', name: 'DesignTestFrameworkAsm08' },
      { path: '/design-test/framework-asm-09', label: '设计测试 14', name: 'DesignTestFrameworkAsm09' },
      { path: '/design-test/framework-asm-10', label: '设计测试 15', name: 'DesignTestFrameworkAsm10' },
      {
        path: '/design-test/building-efficiency-procurement',
        label: '设计测试 16',
        name: 'DesignTestBuildingProcurementPackage',
      },
      {
        path: '/design-test/building-efficiency-hoist-slots',
        label: '设计测试 17',
        name: 'DesignTestBuildingHoistSlotBoard',
      },
      {
        path: '/design-test/building-efficiency-handover',
        label: '设计测试 18',
        name: 'DesignTestBuildingHandoverLedger',
      },
      {
        path: '/design-test/building-efficiency-rfi-matrix',
        label: '设计测试 19',
        name: 'DesignTestBuildingRfiMatrix',
      },
      {
        path: '/design-test/app-mini-pmsmart-functions',
        label: '设计测试 20',
        name: 'DesignTestAppMiniPmsmartFunctionsHub',
        ...(designTest20TunnelHref ? { externalHref: designTest20TunnelHref } : {}),
      },
      {
        path: '/design-test/dt-21-mep-cable-inbound-list',
        label: '设计测试 21',
        name: 'DesignTest21MepCableInboundList',
      },
      {
        path: '/design-test/dt-22-part-loss-analysis',
        label: '设计测试 22',
        name: 'DesignTest22PartLossAnalysis',
      },
      {
        path: '/design-test/dt-23-pmsmart-2026-mastergo',
        label: '设计测试 23',
        name: 'DesignTest23Pmsmart2026Mastergo',
      },
      {
        path: '/design-test/dt-24-loss-rate-setting',
        label: '设计测试 24',
        name: 'DesignTest24LossRateSetting',
      },
      {
        path: '/design-test/dt-25-inspect-status-tag',
        label: '设计测试 25',
        name: 'DesignTest25InspectStatusTag',
      },
      {
        path: '/design-test/dt-26-rebar-opt-rate-report',
        label: '设计测试 26',
        name: 'DesignTest26RebarOptRateReport',
      },
      {
        path: '/design-test/dt-27-rebar-opt-report-workbench',
        label: '设计测试 27',
        name: 'DesignTest27RebarOptReportWorkbench',
      },
      {
        path: '/design-test/dt-28-rebar-opt-report-sidebar',
        label: '设计测试 28',
        name: 'DesignTest28RebarOptReportSidebar',
      },
      {
        path: '/design-test/dt-29-concrete-pour-order',
        label: '设计测试 29',
        name: 'DesignTest29ConcretePourOrder',
      },
      {
        path: '/design-test/dt-30-app-mini-functions',
        label: '设计测试 30',
        name: 'DesignTest30AppMiniPmsmartFunctionsHub',
      },
      {
        path: '/design-test/dt-31-app-mini-functions',
        label: '设计测试 31',
        name: 'DesignTest31AppMiniPmsmartFunctionsHub',
      },
      {
        path: '/design-test/dt-32-rebar-budget-multi-panel',
        label: '设计测试 32',
        name: 'DesignTest32RebarBudgetMultiPanel',
      },
      {
        path: '/design-test/dt-32-1-rebar-budget-multi-panel',
        label: '设计测试 32-1',
        name: 'DesignTest321RebarBudgetMultiPanel',
      },
      {
        path: '/design-test/overview-jijian',
        label: '设计测试 33',
        name: 'DesignTest33MixAppOverview',
      },
      {
        path: '/design-test/dt-34-mix-overview-viz',
        label: '设计测试 34',
        name: 'DesignTest34MixAppOverview',
      },
      {
        path: '/design-test/dt-35-mep-cable-loss-dashboard',
        label: '设计测试 35',
        name: 'DesignTest35MepCableLossDashboard',
      },
      {
        path: '/design-test/dt-36-pmsmart-analytics-dashboard',
        label: '设计测试 36',
        name: 'DesignTest36PmsmartAnalyticsDashboard',
      },
      {
        path: '/design-test/dt-37-mep-cable-quota-hub-tertiary',
        label: '设计测试 37 · 机电管理 Web v2',
        name: 'DesignTest37MepCableQuotaHubTertiary',
      },
      {
        path: '/design-test/dt-38-app-mini-functions',
        label: '设计测试 38 · App功能 v2',
        name: 'DesignTest38AppMiniPmsmartFunctionsHub',
      },
      {
        path: '/design-test/dt-39-formwork-plan-calc',
        label: '设计测试 39 · 模架策划计算',
        name: 'DesignTest39FormworkPlanCalc',
      },
      {
        path: '/design-test/dt-40-issue-ledger',
        label: '设计测试 40 · 问题台账',
        name: 'DesignTest40IssueLedger',
      },
      {
        path: '/design-test/dt-41-app-mini-functions',
        label: '设计测试 41 · App v3',
        name: 'DesignTest41AppMiniPmsmartFunctionsHub',
      },
      {
        path: '/design-test/dt-42-ai-rebar-sample-upload',
        label: '设计测试 42 · AI单据·钢筋翻样单',
        name: 'DesignTest42AiRebarSampleUpload',
      },
      {
        path: '/design-test/dt-43-rebar-opt-ai-sidebar',
        label: '设计测试 43 · 钢筋优化·AI侧边栏',
        name: 'DesignTest43RebarOptAiSidebar',
      },
      {
        path: '/design-test/dt-44-infra-pour-order-app',
        label: '设计测试 44 · 基建浇筑令 App',
        name: 'DesignTest44InfraPourOrderApp',
      },
      {
        path: '/design-test/dt-45-infra-pour-order-app',
        label: '设计测试 45 · 基建浇筑令 App（入口改版）',
        name: 'DesignTest45InfraPourOrderApp',
      },
      {
        path: '/design-test/dt-46-rebar-plan-efficiency-nav',
        label: '设计测试 46 · 钢筋策划创效（导航壳）',
        name: 'DesignTest46RebarPlanEfficiencyNav',
      },
      {
        path: '/design-test/dt-47-system-screenshot-cell',
        label: '设计测试 47 · 问题台账·系统截图加载',
        name: 'DesignTest47SystemScreenshotCell',
      },
      {
        path: '/design-test/dt-48-drawing-list-ai-parse',
        label: '设计测试 48 · 图纸列表·AI解析条',
        name: 'DesignTest48DrawingListAiParse',
      },
      {
        path: '/design-test/dt-49-rebar-combo-calc-dialog',
        label: '设计测试 49 · 钢筋组合下料 · 计算中浮层',
        name: 'DesignTest49RebarComboCalcDialog',
      },
      {
        path: '/design-test/dt-50-rebar-data-analysis-summary',
        label: '设计测试 50 · 钢筋优化 · 数据分析汇总',
        name: 'DesignTest50RebarDataAnalysisSummary',
      },
      {
        path: '/design-test/dt-51-rebar-data-analysis-summary',
        label: '设计测试 51 · 钢筋优化 · 数据分析汇总',
        name: 'DesignTest51RebarDataAnalysisSummary',
      },
      {
        path: '/design-test/dt-52-mix-notice-app',
        label: '设计测试 52 · 配合比通知单 App',
        name: 'DesignTest52MixNoticeApp',
      },
      {
        path: '/design-test/dt-53-drawing-model-analysis',
        label: '设计测试 53 · 图模分析弹窗',
        name: 'DesignTest53DrawingModelAnalysis',
      },
    ],
  },
];

export const ALL_DESIGN_TEST_ITEMS = DESIGN_TEST_NAV_GROUPS.flatMap((g) => g.items);

/** 侧栏展示：页面模板倒序（最新编号在上），且该分组置顶 */
export const DESIGN_TEST_NAV_GROUPS_SIDEBAR = (() => {
  const groups = DESIGN_TEST_NAV_GROUPS.map((g) =>
    g.key === 'page-templates' ? { ...g, items: [...g.items].reverse() } : { ...g },
  );
  const pageTemplatesIdx = groups.findIndex((g) => g.key === 'page-templates');
  if (pageTemplatesIdx > 0) {
    const [pageTemplates] = groups.splice(pageTemplatesIdx, 1);
    groups.unshift(pageTemplates);
  }
  return groups;
})();
